export default __webpack_public_path__ + "static/media/line.efdf9665.svg";